<p class="po-font-subtitle health-errors__heading" *ngIf="showHeading">Causas das falhas</p>

<ul class="health-errors__list">
  <li class="health-errors__card" *ngFor="let card of cards; let i = index">
    <div class="health-errors__header">
      <po-tag [p-value]="card.countLabel" [p-type]="card.countType" p-inverse="true"></po-tag>
      <div class="health-errors__title">
        <span class="po-font-text-large-bold">{{ card.title }}</span>
        <span class="po-font-text-small">{{ card.subtitle }}</span>
      </div>
      <div class="health-errors__states">
        <po-tag *ngIf="card.retryingLabel" [p-value]="card.retryingLabel" p-type="warning"></po-tag>
        <po-tag *ngIf="card.stalledLabel" [p-value]="card.stalledLabel" p-type="warning" [p-inverse]="true"></po-tag>
        <po-tag *ngIf="card.deadLabel" [p-value]="card.deadLabel" p-type="danger"></po-tag>
      </div>
    </div>

    <div class="health-errors__cause" *ngIf="card.cause">
      <span class="po-font-text-small-bold">Causa</span>
      <p class="po-font-text">{{ card.cause }}</p>
    </div>

    <p class="po-font-text-small health-errors__hint" *ngIf="card.hint">
      <span class="po-icon po-icon-info" aria-hidden="true"></span>{{ card.hint }}
    </p>

    <div class="health-errors__reviews" *ngIf="card.reviews.length">
      <span class="po-font-text-small-bold">Reviews afetados</span>
      <div class="health-errors__review-links">
        <po-button *ngFor="let review of card.reviews" p-kind="tertiary" p-small="true"
          p-icon="po-icon po-icon-eye" [p-label]="review.label" (p-click)="openReview(review)"></po-button>
      </div>
    </div>

    <po-button class="health-errors__toggle" p-kind="tertiary" p-small="true"
      [p-icon]="expanded.has(i) ? 'po-icon po-icon-arrow-up' : 'po-icon po-icon-arrow-down'"
      [p-label]="expanded.has(i) ? 'Ocultar mensagem técnica' : 'Ver mensagem técnica'"
      (p-click)="toggleMessage(i)"></po-button>
    <pre class="health-errors__message" *ngIf="expanded.has(i)">{{ card.message }}</pre>
  </li>
</ul>
